import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  // UncontrolledTooltip,
} from 'reactstrap';

// import { EXPORT_LIMIT } from 'pages/Products/ProductsExport/constants';
import { FaFileExcel } from 'react-icons/fa';
import { ProductListButtonIconSize } from '../ProductConstants';
// import { formatNumberWithCommas } from 'utils/maths/Str2Num';

interface ExportButtonProps {
  // fetchExportQuantity: () => Promise<void>;
  _limitData: number;
  toggleExportInformationModal: (x: boolean) => void;
  toggleExportQuantityModal: (x: boolean) => void;
}
const ExportButton = ({
  // fetchExportQuantity,
  _limitData,
  toggleExportInformationModal,
  toggleExportQuantityModal,
}: ExportButtonProps) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const { t } = useTranslation();

  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      className="material-shadow btn-group"
    >
      <DropdownToggle
        caret
        className="btn-soft-info material-shadow-none d-flex align-items-center"
        id="btn-export"
      >
        {/* <i className="ri-file-download-line align-bottom me-1"></i>{' '} */}
        <div className="d-flex align-items-center">
          <FaFileExcel size={ProductListButtonIconSize} className="mx-1" />
          {/* <FaFileExcel size={14} className="mx-1" /> */}
        </div>
        <div className="d-flex">{t('Export')}</div>
        {/* {limitData > EXPORT_LIMIT && (
          <UncontrolledTooltip placement="top" target="btn-export">
            {`${t('Cannot export data more than ')}${formatNumberWithCommas(
              EXPORT_LIMIT,
              0
            )} ${t('un_items')}`}
          </UncontrolledTooltip>
        )} */}
      </DropdownToggle>

      <DropdownMenu className="dropdownmenu-info">
        <DropdownItem
          className="text-steel-gray"
          onMouseOver={(e) =>
            e.currentTarget.classList.remove('text-steel-gray')
          }
          onMouseOut={(e) => e.currentTarget.classList.add('text-steel-gray')}
          onClick={async () => {
            // await fetchExportInformationData();
            toggleExportInformationModal(true);
          }}
          // disabled={limitData > EXPORT_LIMIT}
        >
          {t('Item Information')}
        </DropdownItem>
        <DropdownItem
          className="text-steel-gray"
          onMouseOver={(e) =>
            e.currentTarget.classList.remove('text-steel-gray')
          }
          onMouseOut={(e) => e.currentTarget.classList.add('text-steel-gray')}
          onClick={async () => {
            // await fetchExportQuantity();
            toggleExportQuantityModal(true);
          }}
          // disabled={limitData > EXPORT_LIMIT}
        >
          {t('Quantity')}
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default ExportButton;
